import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

import { useTranslation } from "react-i18next";


function AlertIcon({ imagePath, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();


  return (
    <section
      className={styles.wrapper}
      onMouseOver={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      data-testid="alert-wrapper"
    >
      <img className={styles.image} src={imagePath} alt={t('ALERT_ICON')} />
      <span
        className={[styles.boxAlert, isOpen ? styles.isOpen : ''].join(' ')}
      >
        <strong className={styles.boxText}>{children}</strong>
      </span>
    </section>
  );
}

AlertIcon.propTypes = {
  imagePath: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};

export default AlertIcon;
